import { TranslatedText } from "@/components/common/text";

export const ProfileSection = ({ title, description, children, nextToTitle }) => {
    return (
        <div className="flex flex-col mb-12">
            <div className="flex flex-row items-center">
                <h4 className="leading-9 text-2xl text-cm-p-text-primary font-medium">
                    <TranslatedText>{title}</TranslatedText>
                </h4>
                {nextToTitle ? <div className="ml-4">{nextToTitle}</div> : null}
            </div>
            {description && (
                <div className="text-cm-p-text-secondary">
                    <TranslatedText> text={description}</TranslatedText>
                </div>
            )}
            {children && <div className="mt-4">{children}</div>}
        </div>
    );
};
